export default __webpack_public_path__ + "static/media/logo.340f05fb.png";